<script>
	import { fade } from "svelte/transition";
	import { navigate } from "svelte-routing";
	import { registerFormStart } from "../../tealium";

	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let lastVisitedPage = null;
	export let title = null;

	pageNumber.update((p) => pageIndex);
	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	//  Get the user Agent
	$model.UserAgent = navigator.userAgent;
	$model.referrer = document.referrer;
	$model.RegistrationSegmentId = null;
</script>

<PageSection>
	<div class="row justify-content-center">
		<div class="col-md-8 col-sm-12">
			<h1 class="text-center">Register for the {projectSettings.classActionName}</h1>
		</div>
	</div>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<p></p>

			<p>
				You are able to register for the Ruby Princess Coronavirus Class Action if:<br />
			</p>
			<ul>
				<li>
					You were one of the passengers on the Ruby Princess that departed Circular Quay on 8 March 2020
					(regardless of whether or not you contracted coronavirus).
				</li>
				<li>
					You are an executor, administrator or personal representative of the estate of a passenger who
					contracted coronavirus on the cruise and subsequently passed away.
				</li>
				<li>
					You are a family member or loved one of an ill or deceased passenger who has suffered a psychiatric
					injury (such as PTSD or nervous shock) as a result of their loved one's contracting the virus on the
					cruise
				</li>
			</ul>
			<p>
				To register on a confidential, no-cost, no-obligation basis, please click on the button below and fill
				out the registration form.
			</p>
		</div>
	</div>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12 text-center">
			<NavigationButtons
				showPrevious="false"
				{nextPage}
				nextPageLabel="REGISTER FOR THE CLASS ACTION"
				verifyCaptcha="true"
				tealiumTag={false}
				pageName={title}
				onNext={() => registerFormStart()}
			>
				></NavigationButtons
			>
		</div>
		<div class="col-md-8 col-sm-12 text-center">
			<div class="recaptcha">
				<div id="g-recaptcha" data-sitekey={projectSettings.gSiteKey2}></div>
			</div>
		</div>
	</div>
	<div class="row justify-content-md-center" style="margin-top: 12px;">
		<div class="col-md-8 col-sm-12">
			<p>
				If you require support completing your registration or you are unsure whether you can participate in the
				class action, please contact Shine Lawyers on
				<span style="white-space:nowrap">{projectSettings.phoneNumber}</span> or via email
				<a href="mailto:{projectSettings.emailAddress}" target="_blank" rel="noreferrer noopener"
					>{projectSettings.emailAddress}</a
				>.
			</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2,
	h3 {
		font-size: 1.1em;
		margin-bottom: 16px;
	}

	h2 {
		font-weight: 700;
	}

	.recaptcha {
		padding-top: 20px;
		display: flex;
		justify-content: center;
	}
</style>
